import { render, staticRenderFns } from "./OtherInfo.vue?vue&type=template&id=7cdd6590&scoped=true"
import script from "./OtherInfo.vue?vue&type=script&lang=js"
export * from "./OtherInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdd6590",
  null
  
)

export default component.exports